import { createAction } from 'redux-act';

/**
 * Create the action
 */

export const userSubjectUpdate = createAction('NEW_TIMESLOT_USER_SUBJECT_UPDATE');
export const roomUpdate = createAction('NEW_TIMESLOT_ROOM_UPDATE');
export const timeslotUpdate = createAction('NEW_TIMESLOT_TIMESLOT_UPDATE');
export const durationUpdate = createAction('NEW_TIMESLOT_DURATION_UPDATE');
export const blockUpdate = createAction('NEW_TIMESLOT_BLOCK_UPDATE');
export const recurrenceUpdate = createAction('NEW_TIMESLOT_RECURRENCE_UPDATE');
export const startDateUpdate = createAction('NEW_TIMESLOT_START_DATE_UPDATE');
export const newTimeslotLoad = createAction('NEW_TIMESLOT_LOAD_DATA');
export const newTimeslotReset = createAction('NEW_TIMESLOT_RESET');

export function userSubject(userSubject) {
    return userSubjectUpdate({
        userSubject
    });
}

export function recurrence(recurrence) {
    return recurrenceUpdate({
        recurrence
    });
}

export function startDate(start_date) {
    return startDateUpdate({
        start_date
    });
}

export function room(room) {
    return roomUpdate({
        room
    });
}

export function block(block) {
    return blockUpdate({
        block
    });
}

export function timeslot(timeslot) {
    return timeslotUpdate({
        timeslot
    });
}

export function duration(duration) {
    return durationUpdate({
        duration
    });
}

export function resetNewTimeslot() {
    return newTimeslotReset();
}

export function loadNewTimeslot(timeslot) {
    return newTimeslotLoad({
        ...timeslot
    });
}